export default "__VITE_ASSET__B06GcAZ0__"